var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankRmbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-20 -26.813 677.325 677.325",
    width: 677.325,
    height: 677.325,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n"))), /*#__PURE__*/React.createElement("rect", {
    y: -26.813,
    width: 677.325,
    height: 677.325,
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    x: -20,
    rx: 81.07,
    ry: 81.07
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 438 210.2 C 448 210.2 457.3 213.3 466.1 218.9 L 497.9 238.8 L 527.2 230.1 L 570.2 178.3 L 478.5 86.6 C 442.4 50.5 390.6 30.5 333.8 30.5 L 332.5 30.5 C 306.1 11.3 268 0 228.5 0 C 211.9 0.1 195.4 2 179.2 5.6 C 186 25.2 200 48 210.9 64 C 121.5 115.6 60 221.3 60 343 C 60 367.3 62.5 379.8 62.5 379.8 C 62.5 379.8 91.9 349.9 130.6 349.9 C 130.6 409.8 92.6 467.8 92.6 467.8 C 189.3 467.8 362 513.3 423.7 555.1 C 423.7 526.4 362 454.7 302.7 416 C 302.7 416 476.7 491.5 502.9 623.7 C 502.9 623.7 516 596.3 516 551.4 C 516 351.8 258.4 357.4 256.6 191.6 C 256 147.3 274.1 119.9 274.1 119.9 C 270.1 136.9 268 154.3 267.8 171.7 C 267.8 299.5 401.9 305.2 486.1 385.6 L 504.2 287.7 L 469.3 298.9 L 443.7 291.4 C 415.6 283.3 399.4 267.1 399.4 246.5 C 399.4 225.9 415.5 210.2 438 210.2 Z M 331.9 108.1 C 331.9 108.1 353.1 105.6 368.1 105.6 C 399.3 105.6 429.2 116.2 447.3 132.4 L 428.6 154.9 C 412.4 136.2 360 110.6 331.9 108.1 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankRmbIcon);
export default __webpack_public_path__ + "static/media/bank-rmb-icon.8fb5040f8a93c057496357cf6e51c52e.svg";
export { ForwardRef as ReactComponent };